import { render, staticRenderFns } from "./SitePopupItem.vue?vue&type=template&id=e5080ae4&"
import script from "./SitePopupItem.vue?vue&type=script&lang=js&"
export * from "./SitePopupItem.vue?vue&type=script&lang=js&"
import style0 from "./SitePopupItem.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/fiksucity/city-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5080ae4')) {
      api.createRecord('e5080ae4', component.options)
    } else {
      api.reload('e5080ae4', component.options)
    }
    module.hot.accept("./SitePopupItem.vue?vue&type=template&id=e5080ae4&", function () {
      api.rerender('e5080ae4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sitepopup/SitePopupItem.vue"
export default component.exports